import { render, staticRenderFns } from "./ExpansionPanelForDocuments.vue?vue&type=template&id=52b9e8dd&scoped=true&"
import script from "./ExpansionPanelForDocuments.vue?vue&type=script&lang=js&"
export * from "./ExpansionPanelForDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ExpansionPanelForDocuments.vue?vue&type=style&index=0&id=52b9e8dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b9e8dd",
  null
  
)

export default component.exports